var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e2f6ff;}.b{fill:#5bb2dc;}.c{fill:#f2f2f2;}.d{fill:#61ccff;}.e,.g{fill:#fff;}.e{opacity:0.2;}.f{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-874 -243)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 75.5,
    cy: 75.5,
    r: 75.5,
    transform: "translate(874 243)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(860 284)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.844,25.634h-4.272v-5.7a19.938,19.938,0,0,0-39.875,0v5.7H65.424A1.423,1.423,0,0,0,64,27.058v35.6a5.7,5.7,0,0,0,5.7,5.7h39.876a5.7,5.7,0,0,0,5.7-5.7v-35.6A1.423,1.423,0,0,0,113.844,25.634Zm-12.817,0H78.241v-5.7a11.393,11.393,0,1,1,22.786,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128,38.422a17.09,17.09,0,0,1,34.179,0v5.7h-2.848v-5.7a14.241,14.241,0,0,0-28.483,0v5.7H128Z",
    transform: "translate(-55.455 -18.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M130.906,247.512a2.852,2.852,0,0,1-2.848,2.848H88.182a2.852,2.852,0,0,1-2.848-2.848V213.333h45.572Z",
    transform: "translate(-18.486 -184.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M91.03,247.512V213.333h-5.7v34.179a2.852,2.852,0,0,0,2.848,2.848h4.985C91.988,250.36,91.03,249.082,91.03,247.512Z",
    transform: "translate(-18.485 -184.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M370.136,213.333v34.179c0,1.57-.959,2.848-2.136,2.848h4.984a2.852,2.852,0,0,0,2.848-2.848V213.333Z",
    transform: "translate(-263.412 -184.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M215.664,287.611l-.9,8.079a1.425,1.425,0,0,0,1.416,1.581h5.7a1.425,1.425,0,0,0,1.416-1.581l-.9-8.079a5.634,5.634,0,0,0,2.331-4.581,5.7,5.7,0,0,0-11.393,0A5.634,5.634,0,0,0,215.664,287.611Z",
    transform: "translate(-129.395 -240.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M237.516,298.667a2.839,2.839,0,0,1,1.229,5.4,1.425,1.425,0,0,0-.8,1.439l.823,7.4h-2.514l.823-7.4a1.425,1.425,0,0,0-.8-1.439,2.839,2.839,0,0,1,1.229-5.4Z",
    transform: "translate(-147.882 -258.791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M236.408,304.185a2.775,2.775,0,0,1-.318-1.246,2.852,2.852,0,0,1,2.848-2.848,2.807,2.807,0,0,1,1.163.261,2.84,2.84,0,1,0-3.816,3.716C236.339,304.094,236.359,304.153,236.408,304.185Z",
    transform: "translate(-147.88 -258.791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M248.632,349.631l-.331-2.976c-.094-.081-.15-.2-.265-.252a2.906,2.906,0,0,1-.736-.522,1.369,1.369,0,0,1,.107.538l-.823,7.4h1.583Z",
    transform: "translate(-158.206 -299.702)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7b4a891a.svg";
export { ForwardRef as ReactComponent };